/** Dedicated customer-cloud tenants (or legacy cloud=private) receive .lic files. */
export function needsLicenceFile(tenantOrForm) {
  if (!tenantOrForm) return false;
  const hosting = String(tenantOrForm.hosting || "").toLowerCase();
  if (hosting === "dedicated") return true;
  if (hosting === "shared") return false;
  return String(tenantOrForm.cloud || "").toLowerCase() === "private";
}
